import TicketPaymentContainer from "../../../Component/Application/TicketPayment/TicketPaymentContainer";

const TicketingPage = () => {
    return (
        <div className="page-body">
            <TicketPaymentContainer />
        </div>
    );
};

export default TicketingPage;